module.exports = __webpack_public_path__ + "static/media/dropUPForCollapse.d7e9ba09.svg";